// extracted by mini-css-extract-plugin
export default {"itemContainer":"ProfileMenuItem_itemContainer--awT","itemContainerHigher":"ProfileMenuItem_itemContainerHigher--TKB","wideItem":"ProfileMenuItem_wideItem--NUz"};